import styled from "styled-components";
import { Paper as MuiPaper, Grid, Typography } from "@mui/material";

const Paper = styled(MuiPaper)`
  margin: 2px 10px;
  padding: 15px 10px;
`;

const GridContainer = styled(Grid)`
  height: 100%;
  align-items: center;
`;

export default function Footer() {
  return (
    <Paper>
      <GridContainer container>
        <Grid size>
          {/* <Link color={colors.publicisBlue} href="mailto:adtech@verismart.ai">
            Contact Us
          </Link> */}
        </Grid>

        <Grid size>
          <Typography variant="subtitle2" align="right">
            {`Publicis © ${new Date().getFullYear()} `}
          </Typography>
        </Grid>
      </GridContainer>
    </Paper>
  );
}
